import { render, staticRenderFns } from "./Restricted.vue?vue&type=template&id=05be59fc&"
import script from "./Restricted.vue?vue&type=script&lang=ts&"
export * from "./Restricted.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports